import ModalV2 from '@/components/ModalV2';
import { FiStar } from '@/components/react-icons/main';
import IconV2 from '@/components/v2/IconV2';
import findStepApp from '@/lib/findStepApp.js';
import { setModalState } from '@/redux/actions/uiActions/modalActions';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors';
import memoizeSelector from '@/redux/lib/memoizeSelector';
import selectors from '@/redux/selectors/selectors.js';
import { modal, param } from '@/redux/selectors/uiSelectors';
import { activeWorkflowSimpleSteps } from '@/screens/workflows/redux/selectors/workflowScreenSelectors';
import utilityAppIcons from '@/screens/workflows/schema/utilityAppIcons';
import { useSelector } from 'react-redux';

const LogContextModal = () => {
  const workflowId = useArgSelector(param, 'workflowId');
  const modalState = useSelector(memoizeSelector('modal:logContext', (state) => modal(state, 'logContext')));
  const appsVersions = useSelector(selectors.appsVersions);
  const workflowSteps = useSelector(memoizeSelector(`workflowSlimSteps-${workflowId}`, activeWorkflowSimpleSteps));
  const context = modalState?.context || [];
  const isOpen = modalState?.open === true;

  const mappedContext = context.map((item) => {
    const step = workflowSteps.find((step) => step.id === item.stepId);
    return { ...item, step: { ...step, icon: findStepApp(step, appsVersions)?.icon } };
  });

  const handleClose = () => {
    setModalState('logContext', { open: false });
  };

  return (
    <ModalV2 show={isOpen} title="Step Context" onHide={handleClose} className="log-context-modal">
      <div className="context-container">
        {mappedContext.map((item, index) => (
          <div key={index} className="context-item">
            <div className="context-item-step-id">
              <IconV2 icon={item?.step?.icon || utilityAppIcons[item?.step?.slug] || FiStar} />
              {item?.step?.stepNumber && <div className={'step-number'}>{item?.step?.stepNumber}</div>}
              <div className={'step-message'}>{item?.step?.message}</div>
            </div>
            <div>
              {item.length} item{item.length > 1 ? 's' : ''}
            </div>
          </div>
        ))}
      </div>
    </ModalV2>
  );
};

export default LogContextModal;
